module.exports = __webpack_public_path__ + "img/5.843cf31b.jpg";